import Loader from 'components/loader'
import { useAuth } from 'context/auth'
import React, { useState } from 'react'
import Api from 'utils/api'

const Delete = ({ user, userDeleted, idx }) => {
  const { cardholders, setCardholders } = useAuth() || {}
  const [processing, setProcessing] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [error, setError] = useState('')

  const openModal = () => {
    setError('')
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const handleDelete = async () => {
    setProcessing(true)
    const { response, error: apiError } = await Api('/user?user_id=' + user._id, 'delete')
    setProcessing(false)
    const failure = apiError || (response?.success === false ? response : null)
    if (failure || !response) return setError(failure?.message || 'Could not delete this user.')
    if (typeof setCardholders === 'function' && cardholders !== undefined) setCardholders(cardholders - 1)
    if (typeof userDeleted === 'function') userDeleted(idx)
    closeModal()
  }

  return (
    <div className='tw-p-4'>
      <button
        onClick={openModal}
        className='tw-flex tw-justify-content-between tw-text-medium tw-text-navyBlue tw-invisible group-hover:tw-visible hover:tw-cursor-pointer tw-undefined'
      >
        Delete
      </button>
      {isModalOpen && (
        <div className='tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-z-50'>
          <div className='tw-modal-container tw-bg-white tw-w-1/3 tw-rounded-lg tw-shadow-lg tw-p-4'>
            <h2 className='tw-text-xl tw-mb-4'>
              Are you sure you want to delete?
            </h2>
            {error && (
              <p role='alert' className='tw-text-sm tw-text-red-600'>
                {error}
              </p>
            )}

            <div className='tw-mt-4 tw-flex tw-justify-end'>
              <button
                onClick={handleDelete}
                className='tw-px-4 tw-py-2 tw-bg-red-500 tw-text-white tw-rounded-md tw-mr-2'
              >
                {processing ? <Loader /> : 'Delete'}
              </button>
              <button
                onClick={closeModal}
                className='tw-px-4 tw-py-2 tw-bg-gray-300 tw-rounded-md'
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Delete
